var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mapboxgl-ctrl-bottom-center image-logo"},[_c('img',{attrs:{"src":_vm.url || '/images/logo-fullname-transparent.png',"alt":"logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }